module.exports = __webpack_public_path__ + "media/images/lb/810-1ed253cf9f01e5bc0e5f720c87603225.svg";